import { Icon } from '@iconify/react';

const DownloadSvg = ({ resource }) => {
  return (
    <div className='w-8 h-8 bg-[#3E3E3E] group-hover:bg-[#FCCB16] rounded-full place-self-center flex justify-center items-center transition-colors duration-200'>
      <a
        href={resource.link}
        target='_blank'
        rel='noreferrer'
        className='w-full h-full flex justify-center items-center'
      >
        {resource.type === 'pdf' ? (
          <Icon
            icon='ic:baseline-download'
            className='w-5 h-5 text-[#6C6C6C]'
          />
        ) : (
          <Icon icon='mdi:youtube' className='w-6 h-6 text-[#6C6C6C]' />
        )}
      </a>
    </div>
  );
};

export default DownloadSvg;
